import React, {useMemo, useCallback} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import TemplateEditModalContainer from './TemplateEditModalContainer';
import {CREATE_TEMPLATE_FORM_LOCAL_STORAGE_KEY} from '../../constants/common';

const TemplateCreateModal = ({
  isOpen,
  container,
  onClose,
  currentProject,
  analyticsId,
  resetTemplatesHighlightingRowsAction,
  showNotificationAction
}) => {
  const localStorageKey = useMemo(
    () => `${CREATE_TEMPLATE_FORM_LOCAL_STORAGE_KEY}_${currentProject.id}_${analyticsId}`,
    [analyticsId, currentProject.id]
  );
  const onSaveSuccess = useCallback(() => {
    showNotificationAction({
      type: NotificationTypes.TOAST,
      level: NotificationLevels.SUCCESS,
      message: i18n.t('templatesGrid.newModal.createdMessage')
    });

    // Unhighlight the newly added template in the table after X seconds.
    setTimeout(() => {
      resetTemplatesHighlightingRowsAction();
    }, 3000);
  }, [resetTemplatesHighlightingRowsAction, showNotificationAction]);
  const onSaveError = useCallback(() => {
    showNotificationAction({
      type: NotificationTypes.SNACKBAR,
      level: NotificationLevels.ERROR,
      message: i18n.t('templatesGrid.newModal.errorMessage')
    });
  }, [showNotificationAction]);

  return (
    <TemplateEditModalContainer
      isOpen={isOpen}
      title={i18n.t('templatesGrid.newModal.title')}
      saveButtonText={i18n.t('new.create')}
      savingButtonText={i18n.t('new.creating')}
      container={container}
      onClose={onClose}
      localStorageKey={localStorageKey}
      onSaveSuccess={onSaveSuccess}
      onSaveError={onSaveError}
      allowCreateAnother
    />
  );
};

TemplateCreateModal.displayName = 'TemplateCreateModal';

TemplateCreateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  container: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  currentProject: PropTypes.object.isRequired,
  analyticsId: PropTypes.string.isRequired,
  resetTemplatesHighlightingRowsAction: PropTypes.func.isRequired,
  showNotificationAction: PropTypes.func.isRequired
};

export default TemplateCreateModal;
